import { render } from "./ApprovalProcessType.vue?vue&type=template&id=32681896"
import script from "./ApprovalProcessType.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__